import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { BUTTON_TEXT } from 'src/app/components/projects/constants/dialog-model.constant';
import { DIALOG_CONTENT_TYPE } from './generic-dialog-box.interface';

import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AGENT_POPUP } from 'src/app/components/projects/components/project-details/ai-agent/constants/ai-agent.constant';

@Component({
    selector: 'app-generic-dialog-box',
    imports: [MatButtonModule, MatDialogModule, CommonModule],
    templateUrl: './generic-dialog-box.component.html',
    styleUrls: ['./generic-dialog-box.component.scss']
})
export class GenericDialogBox {
  confirmButton: string = BUTTON_TEXT.CONFIRM;
  cancelButton: string = BUTTON_TEXT.CANCEL;
  dialogContentType = DIALOG_CONTENT_TYPE;
  from:boolean = false;
  chipRemoved = new Subject();
  hasWarningMessage: boolean = false;
  hasInfoMessage: boolean = false;
  source: string = '';
  private dialog: MatDialogRef<GenericDialogBox>;
  @Output() confirmEvent = new EventEmitter<void>();
  private _router :Router;
  isAiAgent:boolean=false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,private router?:Router,private dialogRef?: MatDialogRef<GenericDialogBox>) {
    this.from = data.from === "ImportFromLibrary" || data.from === "selectiveDownload" ? true : false;
    this.source = data.from;
    this.dialog = dialogRef;        
    this._router = router;
    this.hasWarningMessage = data.warning !== undefined && data.warning !== null;
    this.hasInfoMessage = data.info !== undefined && data.info !== null;
    this.isAiAgent=data?.aiAgent;
  }

  removeFromList(item, itemArray) {
    const index = itemArray.findIndex(obj => obj._id === item._id);
    if(index > -1) {
      this.chipRemoved.next(itemArray.splice(index, 1));
      return;
    }
    return [];
  }

  confirm(){
    this.confirmEvent.emit();
    this.dialogRef.close();
    this._router.navigate(['/projects/details']);
  }

  /**
   * A function to decide action on Close of popup.
   * 
   * @param result A string which have the action of closing the Popup
   */
  close = (result:string):void => {
    if (this.isAiAgent) 
      if (result === AGENT_POPUP.CLOSE) this.dialogRef?.close(result);
      else if (result === AGENT_POPUP.REGENERATE) this.dialogRef?.close(result);
      else this.dialogRef?.close(result);
  }
}
